import { lazy, Suspense, useState } from "react";

import { importarComponente } from "@/components/app/staleChunkRecovery";

const VendaDetailModal = lazy(() => importarComponente(() => import("./VendaDetailModal"), "VendaDetailModal"));

/**
 * Cota clicável que abre a venda num modal, sem sair da página (Rick,
 * 18/10/2026: "em todo lugar que dá pra clicar em cota"). Mesmo desenho e
 * mesmos cuidados do GrupoLink: `span` com role (a linha em volta pode ser um
 * botão) e o clique não sobe para a linha. Sem contrato, a venda é buscada
 * pela cota.
 */
export const CotaLink = ({ cota, contrato }: { cota: string; contrato?: string | null }) => {
  const [open, setOpen] = useState(false);
  return (
    <span onClick={(e) => e.stopPropagation()}>
      <span
        role="button"
        tabIndex={0}
        title="Abrir a venda"
        className="cursor-pointer underline decoration-dotted underline-offset-2 hover:text-primary"
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }
        }}
      >
        {cota}
      </span>
      {open && (
        <Suspense fallback={null}>
          <VendaDetailModal contrato={contrato ?? null} cotaBusca={contrato ? null : cota} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </span>
  );
};
